import { create } from "zustand";

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const useJBLogoutModal = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
